<template>
  <div class="current_page">
    <section v-show="!noItemsAvailable">
      <div class="wrapper" :class="type">
        <div class="row">
          <h1 class="itemListTitle">{{ title }}</h1>
        </div>
        <div class="row" v-infinite-scroll="loadItemsBatch" infinite-scroll-disabled="busy" infinite-scroll-distance="10">
          <component
            v-bind:is="cardComponent"
            v-for="item in this.displayedItems"
            :key="item[propertyKey]"
            :[itemName]="item"
            :class="{ spaceFill: item.spaceFill }"
          />
          <div
            v-for="n in fillArr"
            class="box spaceFill"
            :key="n"
          ></div>
        </div>
      </div>
    </section>
    <available-soon
      :noItemsAvailable="noItemsAvailable"
      :itemType="type"
    ></available-soon>
  </div>
</template>

<script>
import Vue from 'vue';
import CardWebtv from "@/components/itemCard/CardWebtv";
import CardWebinars from "@/components/itemCard/CardWebinars";
import CardNews from "@/components/itemCard/CardNews";
import availableSoon from "@/views/plus/itemList/sharedComponents/noAvailableItems";

import infiniteScroll from 'vue-infinite-scroll'
Vue.use(infiniteScroll)

export default {
  name: "itemsList",
  props: [
    "title",
    "cardComponent",
    "itemList",
    "propertyKey",
    "itemName",
    "type",
    "noItemsAvailable",
    "initiatorFunction",
    "symbol"
  ],
  data() {
    return {
      displayedItems: []
    };
  },
  components: { CardWebtv, CardWebinars, CardNews, availableSoon },
  created(){
    this.initiatorFunction(this.symbol).then(() =>{this.loadItemsBatch();});
  },
  computed: {
    fillArr: function() {
      if (!(this.displayedItems === undefined || this.displayedItems.length == 0)) { //todo: check if can remove the condition of undefined
        const remainder = this.displayedItems.length % 3;
        const additionalSpaces = remainder != 0 ? 3 - remainder : 0;
        return new Array(additionalSpaces);
      }
      return [];
    },
  },
  methods:{
    loadItemsBatch: function(){
      const displayedAmount = this.displayedItems.length;
      let additionalAmount = window.matchMedia("(max-width: 768px)").matches
          ? 3
          : 12;
      this.displayedItems = this.itemList.slice(0, displayedAmount+additionalAmount);
    },
  }
};
</script>

<style lang="scss" scoped>
$cardWidth: 20.5rem;
$cardWebinarWidth: 23.375rem;
$cardSideMargin: 15px;
.current_page {
  padding: 50px 0;
  @media only screen and (max-width: 767px) {
    padding: 1.5rem 1rem 0 !important; /*for some reason at the stage, the general app.css for this selector, overrides the current*/
  }
  .wrapper {
    width: 100%;
    padding-right: 30px;
    padding-left: 30px;
    margin-right: auto;
    margin-left: auto;
    position: relative;

    @media only screen and (max-width: 767px) {
      padding-right: 0;
      padding-left: 0;
    }
    h1 {
      margin-bottom: 1.5rem;
      font-size: 1.75rem;
      @media only screen and (max-width: 767px) {
        font-size: 1.25rem;
        width: 100%;
        margin-left: $cardSideMargin;
        margin-right: $cardSideMargin;
      }
    }
    .row {
      display: flex;
      justify-content: center;
      .box {
        display: flex;
        flex-direction: column;
        width: 328px;
        padding: 16px;
        margin-bottom: 30px;
        border-radius: 3px;
        border: 1px solid #d5d3d3;
        -webkit-transition: 0.3s;
        transition: 0.3s;
        cursor: pointer;
        margin-left: $cardSideMargin;
        margin-right: $cardSideMargin;
        &:hover {
          background-color: #f5f5f5;
        }
        &.spaceFill {
          visibility: hidden;
          @media screen and (max-width: 768px){
            display: none;
          }
        }

        @media only screen and (min-width: 768px) {
          min-width: 328px;
        }

        @media only screen and (max-width: 767px) {
          margin-bottom: 1.25rem;
        }
      }
    }
  }

  .wrapper:not(.webinars) {
    max-width: 1450px;
    h1 {
      width: calc(#{$cardWidth * 3} + #{$cardSideMargin * 4});
      @media only screen and (max-width: 1120px) {
        width: calc(#{$cardWidth * 2} + #{$cardSideMargin * 2});
      }
      @media only screen and (max-width: 767px) {
        max-width: $cardWidth;
      }
    }
    @media only screen and (max-width: 767px) {
      max-width: $cardWidth;
    }
  }

  .wrapper.webinars {
    max-width: 1600px;
    @media only screen and (max-width: 860px) {
      padding-right: 0;
      padding-left: 0;
    }
    h1 {
      width: calc(#{$cardWebinarWidth * 3} + #{$cardSideMargin * 4});
      @media only screen and (max-width: 1260px) {
        width: calc(#{$cardWebinarWidth * 2} + #{$cardSideMargin * 2});
      }
      @media only screen and (max-width: 860px) {
        max-width: $cardWebinarWidth;
        font-size: 1.25rem;
        width: 100%;
        margin-left: $cardSideMargin;
        margin-right: $cardSideMargin;
      }
      @media only screen and (max-width: 768px) {
        max-width: $cardWidth;
      }
    }
    @media only screen and (max-width: 860px) {
      max-width: $cardWebinarWidth;
    }
  }
  .webinars .row {
    .box {
      max-width: $cardWebinarWidth;
      @media only screen and (min-width: 768px) {
        min-width: $cardWebinarWidth;
      }
    }
  }
}
</style>
